import { deletePermission } from "../../../db/PermissionsApi";

export default function DeletePermissionModal({
  isOpen,
  onClose,
  permission,
  onDeleted,
  userId,
}) {
  if (!permission) return null;

  const handleDelete = async () => {
    await deletePermission(userId, permission.id);
    onDeleted();
    onClose();
  };

  return (
    <dialog className={`modal ${isOpen ? "modal-open" : ""}`}>
      <div className="modal-box max-w-md">
        <h3 className="font-bold text-lg">Supprimer cette permission ?</h3>

        <p className="mt-4">
          <span className="font-semibold">{permission.code}</span> —{" "}
          {permission.name}
        </p>

        <p className="text-sm text-gray-600 mt-2">
          Cette action est irréversible.
        </p>

        <div className="modal-action">
          <button className="btn btn-outline rounded-full" onClick={onClose}>
            Annuler
          </button>

          <button
            className="btn bg-red-600 text-white rounded-full"
            onClick={handleDelete}
          >
            Supprimer
          </button>
        </div>
      </div>
    </dialog>
  );
}
